module.exports = {
  cmsUrl: 'https://api.angelasielski.com',
  frontendUrl: 'https://www.angelasielski.com'
}
